import axios from 'axios';
import {Base64} from 'js-base64';
import {serialize} from '@/utils/util'
import {getToken} from '@/utils/auth'
import website from '@/utils/website';
import qs from 'qs';
import {Toast} from "vant";

axios.defaults.timeout = 60000;
//axios.defaults.baseURL = 'http://localhost';
//axios.defaults.baseURL = 'http://10.0.100.82';
axios.defaults.withCredentials = true;
//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};

let loading        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
  });
}

function endLoading() {    //使用Element loading-close 方法
  Toast.clear();
}

//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

//http request 拦截器
axios.interceptors.request.use(
  config => {
    showFullScreenLoading();
    config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
    if (localStorage.getItem("token") != null) {
      config.headers['Blade-Auth'] = 'bearer ' + localStorage.getItem("token") // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }

    //headers中配置serialize为true开启序列化
    if (config.method === 'post') {
      if (config.headers['Content-Type'] !== 'multipart/form-data'
        && config.headers['Content-Type'] !== 'application/json') {
        config.data = serialize(config.data);
      } else {
        config.data = config.data;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  res => {
    //debugger;
    const status = res.data.code || 200
    const statusWhiteList = website.statusWhiteList || [];
    const message = res.data.msg || '未知错误';
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);

    tryHideFullScreenLoading();
    //如果是401则跳转到登录页面
    if (status === 401) {
      Toast.fail("登录失效，请重新登录");
      this.$router.push({
        path: "/",
        query: {}
      });
      return;
    }

    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Toast.fail(message);
      return Promise.reject(new Error(message))
    }
    return res;
  },
  error => {
    tryHideFullScreenLoading();
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err)
    })
  })
}


export function fileFetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      responseType: 'arraybuffer'
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function filePost(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        //'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function bodyPost(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js